import { render, staticRenderFns } from "./ModalProtector.vue?vue&type=template&id=65e55cd0"
import script from "./ModalProtector.vue?vue&type=script&lang=js"
export * from "./ModalProtector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports